require('./angular-touch');
module.exports = 'ngTouch';



//////////////////
// WEBPACK FOOTER
// ./~/angular-touch/index.js
// module id = 380
// module chunks = 1